import { SelectionBehavior, Adapter, HTMLListItem } from "./interfaces";

export class SingleSelectionBehavior implements SelectionBehavior {
    constructor(
        private adapter: Adapter<HTMLListItem>,
        private compareFn?: (value: string, item: HTMLListItem) => boolean
    ) {
        if (!compareFn) {
            this.compareFn = (value, item) => item.value === value;
        }
    }

    clearValue() {
        const items = this.adapter.getItems();
        items.forEach((item) => (item.selected = false));
    }

    setValue(value: string) {
        const items = this.adapter.getItems();
        items.forEach((item) => (item.selected = this.compareFn(value, item)));
    }

    select(item: HTMLListItem) {
        const previous = this.adapter.getSelectedItem();
        if (previous) {
            previous.selected = false;
        }

        item.selected = true;
        this.adapter.notifySelect(item);
        this.adapter.setValue(item.value);
    }
}
